import { render, staticRenderFns } from "./ArticleRightSidebar.vue?vue&type=template&id=311512d4&scoped=true&"
import script from "./ArticleRightSidebar.vue?vue&type=script&lang=js&"
export * from "./ArticleRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311512d4",
  null
  
)

export default component.exports